import React, { useState, useEffect, useRef, Fragment } from "react";
import { useStore, useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";

// core components
import LandingNavbar from "components/Navbars/LandingNavbar.js";
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {
  login,
  getUserAll,
  getUserProfile,
  deleteUser,
  approveUser,
  getUserAgenda,
  deleteAgenda,
  createAgenda,
} from "../../actions";
import swal from "sweetalert";
import ReactDatatable from "@ashvin27/react-datatable";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { getUserDiary } from "actions/adminAction";
import { getUserPractice } from "actions/adminAction";
import { useRadioGroup } from "@material-ui/core";
import { TimerSharp } from "@material-ui/icons";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AddUser from "components/AddUser/IndexAddUser";
import UpdateNoteByCounsellor from "components/UpdateNote/IndexUpdateNoteByCounsellor";
import UpdateNoteBySupervisor from "components/UpdateNote/IndexUpdateNoteBySupervisor";
import NoteBySupervisor from "components/UpdateNote/IndexNoteBySupervisor";



function UserPage() {
  useEffect(() => {
    document.body.classList.add("user-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("user-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  // useEffect(() => {
  //   document.body.classList.add("login-page");
  //   document.body.classList.add("sidebar-collapse");
  //   document.documentElement.classList.remove("nav-open");
  //   window.scrollTo(0, 0);
  //   document.body.scrollTop = 0;
  //   return function cleanup() {
  //     document.body.classList.remove("login-page");
  //     document.body.classList.remove("sidebar-collapse");
  //   };
  // }, []);

  const {
    adminGetProfile: userProfile,
    adminGetAllUser: allUser,
    adminGetUserAgenda: userAgenda,
    adminGetUserDiary: userDiary,
    adminGetUserPractice: userPractice
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [token, setToken] = useState(localStorage.getItem("access-token"));
  const [users, setUsers] = useState([]);
  const [counselors, setCounselors] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [counselorSelected, setCounselorSelected] = useState({});
  const [supervisorSelected, setSupervisorSelected] = useState({});
  const [admin, setAdmin] = useState({});
  const [agenda, setAgenda] = useState([]);
  const [diary, setDiary] = useState([]);
  const [practice, setPractice] = useState([]);
  const [planDate, setPlanDate] = useState(new Date());
  const [newPlan, setNewPlan] = useState({
    gid: 0,
    telephone_no: "",
    plan_date: "",
    plan_time: "",
    plan_datetime: "",
  });

  const yourDate = new Date()
  const current = moment(yourDate).format("YYYY-MM-DD").toString();
  

  
  /* const PanelList = (state) => {
    const [active,setActive] = useState();
  
    function activeButton(value){
      setActive(value);
      state.setState({activeMenu: value})
    }

    return (
       <div>
        <MenuButton onChange={activeButton} disabled={active} key={'keycounsellee'} title={'ผู้รับบริการ'}  />
        <MenuButton onChange={activeButton} disabled={active} key={'keycounsellor'} title={'ผู้ให้การปรึกษา'}  />
        <MenuButton onChange={activeButton} disabled={active} key={'keysupervisor'} title={'อาจารย์ผู้ให้การปรึกษา'}  />
       </div>
    )
  };

  const MenuButton = (props) => {

    const clickHandler = (keyID) => {
      props.onChange(keyID)
    };
  
    return (
      <Button
            color={props.active === props.key ? "info" : "basic"}
            className="btn-round"
            onClick={() => clickHandler(props.key)}
          >
            <span style={{fontSize: '20px'}}>{props.title}</span>
      </Button>
    );
  }; */

  

  useEffect(() => {
    setToken(localStorage.getItem("access-token"));
  });

  useEffect(() => {
    if (token) {

      dispatch(getUserProfile());
      if(admin) {
        if(admin.telephone_no1)  dispatch(getUserAgenda(admin.telephone_no1))
      } 
    }
  }, [token]);

  
  const [agendaColumn, setAgendaColumn] = useState([

    {
      key: "plan_date",
      text: "วันที่นัด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "plan_time",
      text: "เวลานัด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "counsellor_full_name",
      text: "ผู้ให้การปรึกษา",
      className: "text-center",
      align: "center",
      sortable: false,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "counselling_room",
      text: "ห้องการปรึกษา",
      className: "text-center",
      align: "center",
      cell:( record) =>{
        var v = record.plan_datetime.split('T');
        if(current==v[0]){
          return  ( 
          <Fragment>
              <Button
                className="btn-round"
                color="info"
                href={`https://meet.jit.si/${record.telephone_no}`}
                target="_blank"
              >
                เข้าห้องรับการปรึกษา
              </Button>
          </Fragment>)
        }else{
          return (<span></span>)
        }
      }
    }
    
  ]);
  const [agendaConfig, setAgendaConfig] = useState({
    key_column: "gid",
    page_size: 5,
    length_menu: [5, 10, 15, 20],
    filename: "รายการนัดหมาย",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: true,
  });
  const [agendaButtons, setAgendaButtons] = useState([
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ]);


    /*

created_by_uid: "471b1400-9199-4dc6-b2db-202ed0ddf735"
created_date: "2020-09-11T23:22:45"
diary_date: "2020-09-11"
emotional_type: 4
event_detail: "เหตุการณ์ที่น่าสนใจ\n"
feeling_detail: ""
gid: 37
idea_detail: ""
is_deleted: false
is_event: true
is_feeling: false
is_idea: false
message_detail: "ดีมาก"
telephone_no: "0801881681"
update_by_uid: "471b1400-9199-4dc6-b2db-202ed0ddf735"
update_date: "2020-09-11T23:22:45"

  */


  const [diaryColumn, setDiaryColumn] = useState([
    {
      key: "diary_date",
      text: "วันที่",
      className: "text-center",
      align: "center",
      sortable: true,
      width: 110,
      cell: (record) => {
       
          return <span>{record.diary_date.replace('T',' ')}</span>;
       
      },
    },
   
    {
      key: "message_detail",
      text: "บันทึกประจำวันนี้",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "emotional_type",
      text: "ระดับความเครียด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },


    {
      key: "event_detail",
      text: "เหตุการณ์ที่ทำให้เกิดอารมณ์/ความเครียด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "idea_detail",
      text: "ความคิด/ความเชื่อต่อเหตุการณ์",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "feeling_detail",
      text: "สิ่งที่มีผลตามมา",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "dispute",
      text: "ทางเลือกอื่นๆ",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
  ]);
  const [diaryConfig, setDiaryConfig] = useState({
    key_column: "gid",
    page_size: 5,
    length_menu: [5, 10, 15, 20],
    filename: "รายการไดอารี่",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: true,
  });
  const [practiceColumn, setPracticeColumn] = useState([
   
    {
      key: "created_date",
      text: "เพิ่มเมื่อ",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
          return <span>{record.created_date.replace('T',' ')}</span>;
       
      },
    },
   
    {
      key: "activating_event",
      text: "เหตุการณ์",
      className: "text-left",
      align: "left",
      sortable: true,
      
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "belief_thought",
      text: "ความคิด/ความเชื่อ",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "consequence_feelings",
      text: "ผลที่ตามมา",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "dispute",
      text: "ทางเลือกอื่นๆ",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    
  ]);
  const [practiceConfig, setPracticeConfig] = useState({
    key_column: "gid",
    page_size: 5,
    length_menu: [5, 10, 15, 20],
    filename: "รายการฝึกคิด",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: true,
  });



  const [isEdit, setIsEdit] = useState(false);
  const [isEditDiary, setIsEditDiary] = useState(false);
  const [isEditPractice,setIsEditPractice] = useState(false);
  const [isAddUserModal,setIsAddUserModal] = useState(false);
  const [userType,setUserType] = useState(false);
  const [isUpdateNoteCounsellorModal,setIsUpdateNoteCounsellorModal] = useState(false);
  const [noteCounsellorModal,setNoteCounsellorModal] = useState({});
  const [isUpdateNoteSupervisorModal,setIsUpdateNoteSupervisorModal] = useState(false);
  const [noteSupervisorModal,setNoteSupervisorModal] = useState({});
  const [isNoteSupervisorModal,setIsNoteSupervisorModal] = useState(false);
  const [selectUser, setSelectUser] = useState({});


  

  useEffect(() => {
    
    if (userProfile.data && !userProfile.isLoading && !userProfile.isFailed) {
      setAdmin(userProfile.data);
    }
  }, [userProfile]);

  useEffect(() => {
    
    if (admin) {
      if(admin.telephone_no1) dispatch(getUserAgenda(admin.telephone_no1));
    }
  }, [admin]);

  useEffect(() => {
    if (userAgenda.data && !userAgenda.isLoading && !userAgenda.isFailed) {
      setAgenda(userAgenda.data);
    }
  }, [userAgenda]);

  const _onLogout = async () => {
    await localStorage.clear();
    await setToken(localStorage.getItem("access-token"));
  };

  

  return (
    <>
      <LandingNavbar
        token={token}
        logout={() => _onLogout()}
        onPage="profile"
        isAdmin={false}
      />
      <div className="wrapper">
      
        <ProfilePageHeader numberOfMember={users.length} profile={admin} isLoadingProfile={userProfile.isLoading} />

        <div className="section">
         
          <Container>
             
          
           
            <Row>

            <Card style={{ width: "100%" }}>
              <CardBody>
                <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                  รายการนัดหมาย
                </CardTitle>
                <ReactDatatable
                  config={agendaConfig}
                  records={agenda}
                  columns={agendaColumn}
                  usersButtons={agendaButtons}
                  loading={userAgenda.isLoading}
                />
              </CardBody>
            </Card>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
     

    
    </>
  );
}

export default UserPage;


export const columns = [
  {
    Header: () => (
      <div />
    ),
    accessor: 'name',
    maxWidth: 300,
    Cell: row => (
      <div className='first-column'>{row.value}</div>
    )
  }
];

export const subComponent = row => {
  return (
    <div>
      abcdefg
      {row.original.types.map((type, id) => {
        return (
          <div className='subRow' key={ id }>{ type.name }</div>
        );
      })}
    </div>
  );
};